/* eslint-disable no-useless-concat */

import React, { useEffect, useRef } from "react";
import "./Feedback.css";

const Feedback = () => {
  const formRef = useRef(null);

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://smtpjs.com/v3/smtp.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = "https://unpkg.com/sweetalert/dist/sweetalert.min.js";
    script2.async = true;
    document.body.appendChild(script2);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  const sendMail = () => {
    let usersname = document.getElementById("username").value;
    let usersemail = document.getElementById("useremail").value;
    let comment = document.getElementById("comments").value;

    let body = "Name: <br/>" + usersname + "<br/>" + "Email: <br/>" + usersemail + "<br/><br/>" + "Comment <br/>" + comment;

    console.log(body);

    window.Email.send({
      Host: "smtp.elasticemail.com",
      Username: "mail@hugenottenrathaus.de",
      Password: "BAAF238142FDFE27699F12B3FC14B1A5C9F7",
      To: "mail@hugenottenrathaus.de",
      From: "mail@hugenottenrathaus.de",
      Subject: "AR App-Free Hugenottenrathaus ",
      Body: body,
    }).then((message) => {
        if (message === "OK") {
          window.swal(
            "Successfull",
            "Thanks! We've received your feedback",
            "success"
          ).then(() => {
            formRef.current.reset(); 
          });
        } else {
          window.swal(
            "Something Wrong",
            "Your FeedBack is not Received",
            "error"
          );
        }
      });
  };

  return (
    <div className="container">
      <h1>Your Feedback</h1>
      <form ref={formRef} onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="username">Name:</label><br/>
        <input type="text" id="username" placeholder="Your Name..." />
        <br />

        <label htmlFor="useremail">Email:</label><br/>
        <input type="text" id="useremail" placeholder="Your Email..." />
        <br />

        <label htmlFor="comments">Please write your comment about the project.</label>
        <br />
        <textarea
          name="message"
          id="comments"
          placeholder="I would Like to say..."
          style={{ height: "200px" }}
        ></textarea>
        <br />
        <button type="button" className="btn" onClick={sendMail}>
          Send Reply
        </button>
      </form>
    </div>
  );
};

export default Feedback;
